import { styled, Typography } from '@mui/material';
import { CheckIcon } from 'assets';
import { palette } from 'view/themes/palette';

export const ChooseRoleItem = styled('div')<{ selected: boolean }>(({ selected }) => {
  return {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '0.2fr 1fr 0.1fr',
    gap: '16px',
    minHeight: '88px',
    height: 'max-content',
    border: `1px solid ${selected ? palette.accent.green500 : palette.border.default}`,
    borderRadius: '16px',
    padding: '16px',
    color: palette.primary.purple500,
    cursor: selected ? 'not-allowed' : 'pointer',
    pointerEvents: selected ? 'none' : 'auto',

    '&:hover': {
      borderColor: selected ? palette.accent.green500 : palette.primary.purple500,
    },
  };
});

export const ChooseRoleItemText = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '21px',
  color: palette.text.header,
  alignSelf: 'center',
}) as typeof Typography;

export const CheckIconCentered = styled(CheckIcon)({
  alignSelf: 'center',
  justifySelf: 'center',
});
